// extracted by mini-css-extract-plugin
module.exports = {"container":"_1fTeQfCdgPyLmyNRjhoF_z","icon":"_3HQj6QmywtGyQA5A0O7ysO","elipsis":"_2b3bcOlZhIVqdT1oz3hXLe","buttonMarker":"_1e6bx499SJry2pQN9-47dR"};